const minin = {
  data() {
    return {
      formInline: {
        ischeck: 2,
      },
      formCtrl: [
        {
          label: "装货日期：",
          keyName: "starttime",
          placeholder: "选择日期",
          type: "date",
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '客户名称', value: 'shname', },
        { label: '承运人', value: 'pcustomname', },
        { label: '车牌号', value: 'license', },
      ],
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "pcustomname", label: "承运人" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "name", label: "货物名称" },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "dprice", label: "司机单价", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', width: 120 },
        { prop: "cmessage", label: "信息费", align: 'right', className: 'pr30', width: 110 },
        { prop: "freight", label: "应收运费", align: 'right', className: 'pr30', width: 120 },
        { prop: "infreight", label: "应付运费", align: 'right', className: 'pr30', width: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/order/nocontractdetail?id=${id}&mode=view`
            );
          },

        },
      ],
      getTotalProperty: ['infreight', 'freight'],
      baseParams: ['ischeck'],
    };
  },
  methods: {},
  created() {
    const { user_group_id } = this.user
    if ([1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns[0] = {
        ...this.editBtn,
        cb: ({ id }) => {
          // console.log(id)
          this.$router.push(
            `/order/nocontractdetail?id=${id}&mode=edit`
          );
        },
      }
    }
  },
  mounted() {
    this.getList()
  },
}

export default minin